/* eslint tailwindcss/no-custom-classname: off */
import { LoginUserMenu, AnonymousUserMenu } from './'
import { useUser } from '@/hooks/useUser'
import { isFacility, isLimitedUrlUser } from '@/utils/user'

export const UserTools: React.FC = () => {
  const user = useUser()
  if (!user || (isFacility(user?.email) && !isLimitedUrlUser(user?.email)))
    return null

  return (
    <div id="user-tools">
      {user?.result ? <LoginUserMenu user={user} /> : <AnonymousUserMenu />}
    </div>
  )
}
